var CookieBanner;

CookieBanner = (function() {
  function CookieBanner(el) {
    this.el = el;
    this.$el = $(this.el);
    this.$body = $('#ls-body');
    this.initialize();
  }

  CookieBanner.prototype.initialize = function() {
    this.delay = 300;
    if (!Cookie.get('acknowledge_cookies')) {
      this.$body.addClass('ls-visible-cookieBanner');
      this.$el.fadeIn(this.delay);
      return this.attachHideListener();
    }
  };

  CookieBanner.prototype.attachHideListener = function() {
    var acknowledgeLink;
    acknowledgeLink = this.$el.find('#ls-accept-cookies');
    return acknowledgeLink.one('click.cookie-banner-action', (function(_this) {
      return function(e) {
        e.preventDefault();
        Groupon.Utils.setSiteCookies({
          acknowledge_cookies: true
        });
        _this.$el.fadeOut(_this.delay).remove();
        return _this.$body.removeClass('ls-visible-cookieBanner');
      };
    })(this));
  };

  return CookieBanner;

})();

window.CookieBanner = CookieBanner;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL2pwdmVyZGVqby9Hcm91cG9uL3Nscy9tb2R1bGVzL2dpZ19ib2R5L2NvbXBvbmVudHMvY29va2llX2Jhbm5lci9mcm9udGVuZC9tYWluLmNvZmZlZSIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi9Vc2Vycy9qcHZlcmRlam8vR3JvdXBvbi9zbHMvbW9kdWxlcy9naWdfYm9keS9jb21wb25lbnRzL2Nvb2tpZV9iYW5uZXIvZnJvbnRlbmQvbWFpbi5jb2ZmZWUiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBQTs7QUFBTTtFQUNTLHNCQUFDLEVBQUQ7SUFBQyxJQUFDLENBQUEsS0FBRDtJQUNaLElBQUMsQ0FBQSxHQUFELEdBQU8sQ0FBQSxDQUFFLElBQUMsQ0FBQSxFQUFIO0lBQ1AsSUFBQyxDQUFBLEtBQUQsR0FBUyxDQUFBLENBQUUsVUFBRjtJQUNULElBQUMsQ0FBQSxVQUFELENBQUE7RUFIVzs7eUJBS2IsVUFBQSxHQUFZLFNBQUE7SUFDVixJQUFDLENBQUEsS0FBRCxHQUFTO0lBQ1QsSUFBQSxDQUFPLE1BQU0sQ0FBQyxHQUFQLENBQVcscUJBQVgsQ0FBUDtNQUNFLElBQUMsQ0FBQSxLQUFLLENBQUMsUUFBUCxDQUFnQix5QkFBaEI7TUFDQSxJQUFDLENBQUEsR0FBRyxDQUFDLE1BQUwsQ0FBWSxJQUFDLENBQUEsS0FBYjthQUNBLElBQUMsQ0FBQSxrQkFBRCxDQUFBLEVBSEY7O0VBRlU7O3lCQU9aLGtCQUFBLEdBQW9CLFNBQUE7QUFDbEIsUUFBQTtJQUFBLGVBQUEsR0FBa0IsSUFBQyxDQUFBLEdBQUcsQ0FBQyxJQUFMLENBQVUsb0JBQVY7V0FDbEIsZUFBZSxDQUFDLEdBQWhCLENBQW9CLDRCQUFwQixFQUFrRCxDQUFBLFNBQUEsS0FBQTthQUFBLFNBQUMsQ0FBRDtRQUNoRCxDQUFDLENBQUMsY0FBRixDQUFBO1FBQ0EsT0FBTyxDQUFDLEtBQUssQ0FBQyxjQUFkLENBQTZCO1VBQUEsbUJBQUEsRUFBcUIsSUFBckI7U0FBN0I7UUFDQSxLQUFDLENBQUEsR0FBRyxDQUFDLE9BQUwsQ0FBYSxLQUFDLENBQUEsS0FBZCxDQUFvQixDQUFDLE1BQXJCLENBQUE7ZUFDQSxLQUFDLENBQUEsS0FBSyxDQUFDLFdBQVAsQ0FBbUIseUJBQW5CO01BSmdEO0lBQUEsQ0FBQSxDQUFBLENBQUEsSUFBQSxDQUFsRDtFQUZrQjs7Ozs7O0FBUXRCLE1BQU0sQ0FBQyxZQUFQLEdBQXNCIn0=
